import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Accessory } from '../../../models/quotation-model/catalogs/accessory.model';
import { AccesoryAmount } from '../../../models/quotation-model/catalogs/accessory-amount.model';
import { AccessoryInsert } from '../../../models/quotation-model/catalogs/accessory-insert.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccesoryService {
  URL_API = environment.apiURL;
  token!: string;

  constructor(private http: HttpClient) {}

  getAccessories(quotationId: number): Observable<Accessory[]> {
    return this.http.get<Accessory[]>(this.URL_API + '/Accessory?quotationId=' + quotationId);
  }

  getAccessoriesAmount(quotationId: number): Observable<AccesoryAmount> {
    return this.http.get<AccesoryAmount>(
      this.URL_API + '/Accessory/GetAmount?quotationId=' + quotationId,
    );
  }

  addAccessory(insertItem: AccessoryInsert) {
    return this.http.post<AccessoryInsert>(this.URL_API + '/Accessory/Insert', insertItem);
  }
}
